import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useResetStore } from '@app/store/resetPasswordStore';
import MagicLinkLayout from '@app/MagicLinkLogin/MagicLinkLayout';
import openToaster from '@app/Toastr/openToastr';

import PasswordChangedCard from './components/PasswordChangedCard';
import ResetPasswordForm from './components/ResetPasswordForm';
import CheckResetToken from './components/CheckResetToken';
import { EResetStatus } from './types';
import TokenErrorCard from './components/TokenErrorCard';

const ResetPassword = () => {
	const { t } = useTranslation('forgotPassword');
	const { resetStatus, tokenMsg, token } = useResetStore();
	const [errorTokenMsg, setErrorTokenMsg] = useState<string | null>(null);

	useEffect(() => {
		if (
			(resetStatus === EResetStatus.EXPIRED ||
				resetStatus === EResetStatus.INVALID_LINK ||
				resetStatus === EResetStatus.LINK_USED_BEFORE) &&
			tokenMsg &&
			tokenMsg !== errorTokenMsg
		) {
			openToaster({
				message: t(tokenMsg),
				variant: 'error',
			});
			setErrorTokenMsg(tokenMsg); // Update the last displayed message
		}
	}, [resetStatus, tokenMsg, errorTokenMsg, t]);

	const resetPasswordContent = () => {
		if (resetStatus === EResetStatus.LOADING) {
			return <CheckResetToken />;
		} else if (
			resetStatus === EResetStatus.EXPIRED ||
			resetStatus === EResetStatus.INVALID_LINK ||
			resetStatus === EResetStatus.LINK_USED_BEFORE
		) {
			return <TokenErrorCard />;
		} else if (resetStatus === EResetStatus.VALID) {
			return <ResetPasswordForm token={token ?? ''} />;
		} else if (resetStatus === EResetStatus.CHANGED_SUCCESSFULLY) {
			return <PasswordChangedCard />;
		}
	};

	return <MagicLinkLayout>{resetPasswordContent()}</MagicLinkLayout>;
};

export default ResetPassword;
